import { TFunction } from 'i18next'
import { ComponentType, IMenuItem } from 'meta/backendControlled/structure'
import {
  IEventCollectionData,
  IEventCollectionDataActiveEvents,
  IEventCollectionDataActiveTypeticketcollections,
  IEventCollectionMetadata,
} from 'meta/pages/v4/eventCollection'

export const getCollectionsMenuItems = (
  details: IEventCollectionData,
  activeEvents: {
    data: Record<number, IEventCollectionDataActiveEvents>
    metadata: IEventCollectionMetadata
  },
  activeTypeticketCollections: {
    data: Record<number, IEventCollectionDataActiveTypeticketcollections>
    metadata: IEventCollectionMetadata
  },
  t: TFunction
): IMenuItem[] => {
  const menuItems: IMenuItem[] = []

  if (!details) {
    return menuItems
  }

  if (details.lineup?.length > 0) {
    menuItems.push({
      title: t('collection:artist_title'),
      anchor: 'artisti',
      componentType: ComponentType.map,
    })
  }

  if (activeTypeticketCollections.metadata.total > 0) {
    menuItems.push({
      title: t('collection:season_tickets_title'),
      anchor: 'abbonamenti',
      componentType: ComponentType.map,
    })
  }

  if (activeEvents.metadata.total > 0) {
    menuItems.push({
      title: t('collection:event_title'),
      anchor: 'eventi',
      componentType: ComponentType.map,
    })
  }

  if (details.longDescription) {
    menuItems.push({
      title: t('collection:info_history_title'),
      anchor: 'info',
      componentType: ComponentType.map,
    })
  }

  // {
  //   title: 'FAQ',
  //   anchor: 'faq',
  //   componentType: ComponentType.map,
  // },
  // {
  //   title: 'Mag',
  //   anchor: 'mag',
  //   componentType: ComponentType.map,
  // },
  // {
  //   title: 'Potrebbe interessarti',
  //   anchor: 'potrebbe',
  //   componentType: ComponentType.map,
  // },

  return menuItems
}
